import Grid from '@mui/material/Grid';
import { useWatch } from 'react-hook-form';

import { useIsChecklessPaymentsEnabled } from 'reservations/account/providers/ConfigProvider';
import CompleteYourReservation from 'reservations/availabilities/components/CompleteYourReservation';
import type { DinerFieldProps } from 'reservations/availabilities/types';
import { useAutoEnrollment } from 'reservations/checklessPayments/hooks/useAutoEnrollment';
import { useIsSubjectToCancellationFee } from 'reservations/feePolicy/hooks';
import { BaseDinerFields } from 'reservations/form/components/BaseDinerFields';
import CreateReservationButton from 'reservations/form/components/CreateReservationButton';

export const CreateFields = ({ handleFormDrawerClose }: DinerFieldProps) => {
  const isChecklessPaymentsEnabled = useIsChecklessPaymentsEnabled();
  useAutoEnrollment(isChecklessPaymentsEnabled);

  const partySize = useWatch({ name: 'partySize' });
  const isSubjectToCancellationFee = useIsSubjectToCancellationFee(partySize);

  const shouldAuthenticate =
    isChecklessPaymentsEnabled || isSubjectToCancellationFee;

  return (
    <>
      <Grid item>
        <CompleteYourReservation />
      </Grid>
      <BaseDinerFields shouldAuthenticate={shouldAuthenticate} />
      <Grid item>
        <CreateReservationButton
          handleFormDrawerClose={handleFormDrawerClose}
        />
      </Grid>
    </>
  );
};
